<template>
    <div>
        <Navbar />
        <PageTitle pageTitle="KIBANX Friends & Family Program"
            pageTagLine="Help you frinds earn money all while you do." />
        <HowItWorks />
        <EarnMoney />
        <Features />
        <StartTrading />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import HowItWorks from '../Affiliate/HowItWorks'
import EarnMoney from '../Affiliate/EarnMoney'
import Features from '../Affiliate/Features'
import StartTrading from '../Affiliate/StartTrading'
import Footer from '../Layouts/Footer'

export default {
    name: 'AffiliateProgramPage',
    components: {
        Navbar,
        PageTitle,
        HowItWorks,
        EarnMoney,
        Features,
        StartTrading,
        Footer,
    }
}
</script>